import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-anti-ragging-affidavits',
  templateUrl: './online-anti-ragging-affidavits.component.html',
  styleUrls: ['./online-anti-ragging-affidavits.component.scss']
})
export class OnlineAntiRaggingAffidavitsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
